import { render, staticRenderFns } from "./edit-donation-teams.vue?vue&type=template&id=ac5a131e&scoped=true&"
import script from "./edit-donation-teams.vue?vue&type=script&lang=js&"
export * from "./edit-donation-teams.vue?vue&type=script&lang=js&"
import style0 from "./edit-donation-teams.vue?vue&type=style&index=0&id=ac5a131e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5a131e",
  null
  
)

export default component.exports